module.exports = __webpack_public_path__ + "static/media/linkedln.67cddf2d.svg";